<template>
  <div class="flex flex-row min-h-screen antialiased font-body">
    <Header v-if="isLoggedIn" class="w-32" />
    <div class="w-full min-h-screen p-4" :class="isLoggedIn ? 'ml-32' : ''">
      <router-view></router-view>
    </div>
    <notifications class="mt-2 mr-4"
      ><template slot="body" slot-scope="{ item, close }">
        <div
          class="px-2 py-1 mt-2 border-l-4 voady-notification"
          @click="close"
        >
          <p class="font-semibold">
            {{ item.title }}
          </p>

          <div v-html="item.text" />
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
import { DefaultApolloClient } from '@vue/apollo-composable'
import gql from 'graphql-tag'
import WebFontLoader from 'webfontloader'
import Header from '@/components/Header'
import LoadingSpinner from '@/components/LoadingSpinner'
import { mapGetters } from 'vuex'
import { provide } from '@vue/composition-api'

export default {
  name: 'App',
  components: { Header, LoadingSpinner },

  setup(props, context) {
    provide(DefaultApolloClient, context.root.$apollo)
  },
  created() {
    WebFontLoader.load({
      typekit: {
        id: 'gkb8aen',
      },
    })
  },

  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
}
</script>

<style src="./assets/main.css"></style>
